export default "__VITE_ASSET__DLH$fJk$__"